module.exports = __webpack_public_path__ + "static/media/scratch_prize_phone.24e8de7f.png";